console.log('💃🏻💃🏻💃🏻💃🏻 Developed by www.drdek.cz 💃🏻💃🏻💃🏻💃🏻')
